import {styled} from "@core-ui/react-stitch";
import {ImageSwatchProps} from "../types";

export const SquareImageSwatch = styled.img<
  Pick<ImageSwatchProps, "selected" | "size" | "boxShadow">
>(({boxShadow}) => ({
  width: "100%",
  height: "100%",
  borderRadius: "0%",
  margin: 0,
  zIndex: 1,
  boxShadow,
}));

export const CircleImageSwatch = styled.img<
  Pick<ImageSwatchProps, "selected" | "size" | "boxShadow">
>(({boxShadow}) => ({
  width: "100%",
  height: "100%",
  borderRadius: "50%",
  margin: 0,
  zIndex: 1,
  boxShadow,
}));
